import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useNytaModalStore } from '@maestra/core/stores/nytaModalStore';
import useIsMobile from '../../utils/isMobile';

// COMO A NYTA ABRE, num lugar só.
//
// ⚠️ NO COMPUTADOR ELA ABRE FLUTUANDO, e não na página /nyta. Decisão de produto (24/09/2026): a
// pessoa precisa ver a conversa e o módulo AO MESMO TEMPO — perguntar sobre a agenda olhando a
// agenda, pedir uma estratégia com o plano aberto. A página em tela cheia tirava o módulo da frente
// justamente quando ele era o assunto.
//
// No celular continua a página: ali o modal já ocupa a tela inteira, e a página é a que funciona
// bem (o cabeçalho e a tab bar saem da frente — ver `isImmersiveRoute` em logica/casca/rotas).
//
// A página /nyta continua existindo no computador, para quem chega por link ou quer a lista de
// conversas: o modal leva até ela pelo "Abrir em tela cheia".
//
// Todo botão que abre a Nyta passa por aqui. Espalhados, cada um decidia do seu jeito, e foi assim
// que o menu lateral abria o modal enquanto o rail, o cabeçalho e a home abriam a página.

const artistaDaRota = (pathname: string): string | undefined =>
  /^\/artists\/([^/]+)/.exec(pathname)?.[1];

export function useAbrirNyta() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const open = useNytaModalStore((s) => s.open);
  const openWithPrompt = useNytaModalStore((s) => s.openWithPrompt);

  return useCallback((pergunta?: string) => {
    const texto = pergunta?.trim();
    const artistId = artistaDaRota(pathname);

    if (isMobile && artistId) {
      navigate(`/artists/${artistId}/nyta${texto ? `?prompt=${encodeURIComponent(texto)}` : ''}`);
      return;
    }
    if (texto) openWithPrompt(texto);
    else open();
  }, [isMobile, navigate, open, openWithPrompt, pathname]);
}
